var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "standard-list-item" }, [
    _c("div", { staticClass: "d-flex flex-row top-row" }, [
      _c(
        "div",
        {
          staticClass: "d-flex flex-row align-center flex-grow-1",
          on: {
            click: function ($event) {
              return _vm.dispatchVirtualList("on-press-item")
            },
          },
        },
        [
          _c(
            "p",
            {
              staticClass: "body-1",
              class: { "font-weight-bold": _vm.isSelected },
            },
            [_vm._v(_vm._s(_vm.source.name))]
          ),
          _vm.isUpdating
            ? _c("v-progress-circular", {
                attrs: {
                  color: _vm.loadingIndicatorUi.color,
                  width: _vm.loadingIndicatorUi.size,
                  indeterminate: "",
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "div",
        {
          on: {
            click: function ($event) {
              $event.stopPropagation()
              $event.preventDefault()
            },
          },
        },
        [
          _c(
            "v-icon",
            {
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                  $event.preventDefault()
                  return _vm.dispatchVirtualList("on-edit-item")
                },
              },
            },
            [_vm._v("edit")]
          ),
          _c(
            "v-menu",
            {
              nativeOn: {
                click: function ($event) {
                  $event.stopPropagation()
                  $event.preventDefault()
                },
              },
              scopedSlots: _vm._u([
                {
                  key: "activator",
                  fn: function (ref) {
                    var on = ref.on
                    return [
                      _c(
                        "v-btn",
                        _vm._g(
                          {
                            attrs: {
                              slot: "activator",
                              icon: "",
                              disabled: _vm.source.disableActions(),
                            },
                            slot: "activator",
                          },
                          on
                        ),
                        [_c("v-icon", [_vm._v("more_vert")])],
                        1
                      ),
                    ]
                  },
                },
              ]),
            },
            [
              _c(
                "v-list",
                _vm._l(_vm.resultActions, function (menuItem, menuIndex) {
                  return _c(
                    "v-list-item",
                    {
                      key: menuIndex,
                      on: {
                        click: function ($event) {
                          return _vm.onMenuItemSelect(menuIndex)
                        },
                      },
                    },
                    [_c("v-list-item-title", [_vm._v(_vm._s(menuItem))])],
                    1
                  )
                }),
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]),
    _vm.source.notes
      ? _c("p", { staticClass: "body-2 text--secondary" }, [
          _vm._v(_vm._s(_vm.resolveItemNotes(_vm.source))),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }